import(/* webpackMode: "eager", webpackExports: ["LandingView"] */ "/vercel/path0/apps/parrot/components/views/LandingView.tsx");
